// import { GameData } from "../gamestate/gameData";
import { Popper } from "../Popper";
import { ClickAwayListener } from "./ClickAwayListener";
import { CommonData } from "../datastructures/gamestate/gameData";

export class BetPopper extends Popper {
    private parent: PIXI.Container;
    private offsetParent:PIXI.Container;
    private parentBtns: PIXI.Container;
    private activeGameData: CommonData;
    private betTitelStake: Array<PIXI.Text>;
    private betTitelStakeButtons: Array<PIXI.Graphics>;
    
    private autoplayTitelStakeButtonsFrames:Array<PIXI.Graphics>;
    private betstacklevel: number;

    private betBGframe: PIXI.Sprite;
    private betWindowTweens: Array<PIXI.tween.Tween>;
    private betSelectFunction: Function;
    private bgTween: PIXI.tween.Tween;
    private isOpen: boolean;
    
    // private offsetY:number;

    constructor(parent: PIXI.Container, selectBet: Function, activeGameData: CommonData) {
        super(activeGameData)
        this.parent = new PIXI.Container();
        this.offsetParent=new PIXI.Container();




        
        parent.addChild(this.parent);

        this.parent.addChild(this.offsetParent)
        this.activeGameData = activeGameData;
        this.betTitelStake = [];
        this.betTitelStakeButtons = [];
        this.autoplayTitelStakeButtonsFrames=[];
        this.betWindowTweens = [];
        this.betstacklevel = 0;
        this.betSelectFunction = selectBet;
        this.betBGframe = new PIXI.Sprite(PIXI.Texture.fromImage("BetBG.png"));

        this.betBGframe.interactive=false;
        this.betBGframe.on('pointertap', function () {
          
            return false
        }.bind(this));

        this.betBGframe.anchor.set(.5,.5)
        this.betBGframe.x = this.activeGameData.size[0] / 2;
        this.betBGframe.y = this.activeGameData.size[1] / 2 //+ 20;
        // this.offsetParent.addChild(this.betBGframe);
        this.offsetParent.addChild(this.betBGframe);
        this.betBGframe.scale.set(activeGameData.gameScale);
        this.parentBtns = new PIXI.Container();
        this.offsetParent.addChild(this.parentBtns);

        this.addClickAwayListener(new ClickAwayListener(this.activeGameData.stage, this.betBGframe, this.close.bind(this)));
        if (activeGameData.isMobile) {
            this.betBGframe.y = this.activeGameData.size[1] / 2;// parent.height/2-50;// + 110 + 35;
            // this.parent.x+=105

        }
        this.isOpen = false;
        this.createBtns();
        this.createTween();
    }

    private createBtns=():void=> {
        for (var i = 0; i < this.activeGameData.betList.length; i++) {
            this.betTitelStakeButtons[i] = new PIXI.Graphics();
            // this.betTitelStakeButtons[i].beginFill(0x111111);
            if (this.activeGameData.isMobile) {
                // this.betTitelStakeButtons[i].lineStyle(5,0xff0000,1) ;
                this.betTitelStakeButtons[i].drawRoundedRect(0, 0, 220, 90 * 1.2, 5);
                this.betTitelStakeButtons[i].endFill();
                this.betTitelStake[i] = new PIXI.Text(this.activeGameData.betList[i].getDisplayValue(), { fontFamily: this.activeGameData.gameTextStyle.gameFont, fontWeight: 'bold', fontSize: 60, fill: "white", align: 'right',  stroke: "#00000055",
                strokeThickness: 15 });;
                // this.betTitelStakeButtons[i].y = 100 * 1.2 * (this.betstacklevel % 6) + 185;
                // this.betTitelStakeButtons[i].y = 85*this.activeGameData.gameScale * (this.betstacklevel ) + 0;
            }

            else {
            
                // this.betTitelStakeButtons[i].beginFill(0x301515);
                this.betTitelStakeButtons[i].drawRoundedRect(0, 0, 200, 90, 5);
                // this.betTitelStakeButtons[i].lineStyle(5,0xff0000,1) ;
                this.betTitelStakeButtons[i].endFill();
                this.betTitelStake[i] = new PIXI.Text(this.activeGameData.betList[i].getDisplayValue(), { fontFamily: this.activeGameData.gameTextStyle.gameFont, fontWeight: 'bold', fontSize: 50, fill: "white", align: 'right',  stroke: "#00000055",
                strokeThickness: 15 });
                // this.betTitelStakeButtons[i].y = 95 * (this.betstacklevel ) + 0;
            }

             //create frames for portrait

             this.autoplayTitelStakeButtonsFrames[i] = new PIXI.Graphics();
             this.autoplayTitelStakeButtonsFrames[i].lineStyle(5,0xffffff,.5) ;
             this.autoplayTitelStakeButtonsFrames[i].beginFill(0x555555,.5);
            this.autoplayTitelStakeButtonsFrames[i].drawRoundedRect(0,0,this.betTitelStakeButtons[i].width ,90,12);
            this.autoplayTitelStakeButtonsFrames[i].endFill();
            this.autoplayTitelStakeButtonsFrames[i].alpha=0;
         //    this.autoplayTitelStakeButtonsFrames[i].x=    this.betTitelStake[i].x/2
            this.betTitelStakeButtons[i].addChild(this.autoplayTitelStakeButtonsFrames[i])
 
            //--
            this.betTitelStakeButtons[i].buttonMode = true;
     
            this.betTitelStakeButtons[i].on('pointertap', this.betSelectFunction.bind(undefined, (i.toString()),this.activeGameData));
          this.betTitelStakeButtons[i].alpha = 1;

          
            this.parentBtns.addChild(this.betTitelStakeButtons[i]);
            this.betTitelStakeButtons[i].addChild(this.betTitelStake[i]);
            this.betTitelStake[i].position.set(this.betTitelStakeButtons[i].width / 2 - this.betTitelStake[i].width / 2, this.betTitelStakeButtons[i].height / 2 - this.betTitelStake[i].height / 2)
            this.betTitelStake[i].anchor.set(1);
            this.betTitelStake[i].x += this.betTitelStake[i].width;
            this.betTitelStake[i].y += this.betTitelStake[i].height;
            //============
            

           
        }

        this.defaultPos();
        this.resize();

        // this.setHorizontalView(true)

        //adjust for mobile version
        // if(this.activeGameData.isMobile)
        // {
        //     // this.betBGframe.x=this.activeGameData.size[0]/2+105;
        //     // this.betBGframe.y=this.activeGameData.size[1]/2;
        //     // this.parent.scale.set(1.2)
        // }
        this.removeFromCanvas();
    }
    private resize=():void=> {


        // for (let i = 0; i < this.betTitelStake.length; i++) {

        //     // console.log(this.betTitelStake[i].width)
        //     // if (this.betTitelStake[i].width > 143)//143 //112
        //     // {
        //     //     this.betTitelStake[i].scale.set(143 / this.betTitelStake[i].width, 1);
          
        //     // }
        // }

        this.betBGframe.height=this.parentBtns.height+120;//always bigger than the bets
        // this.betBGframe.y=0
        this.parentBtns.y=this.activeGameData.size[1] / 2 -this.parentBtns.height/2;
        if(this.activeGameData.isMobile==false)
        {
            this.parent.y+=10
        }

    }





    public setVerticalView=(bool:boolean):void=>
    {
        
        if(bool)
        {
            //disblay in hotizontalMode only true o#
            // let xSplits=this.activeGameData.size[0]/this.autoplayTitelStakeButtons.length
         
            this.parent.scale.set(2);
            let col=0;
            let row=0;
            this.betBGframe.alpha=0;
            for (var i = 0; i < this.betTitelStakeButtons.length; i++) {
                // this.autoplayTitelStakeButtons[i].updateLineStyle(5,0xffffff,.5)
                this.autoplayTitelStakeButtonsFrames[i].alpha=1;
                if(this.activeGameData.isMobile)
                { 
                    this.betTitelStakeButtons[i].x= (this.betTitelStakeButtons[i].width+25)*col-190+210+95+8; 
                    this.betTitelStakeButtons[i].y=row*(this.autoplayTitelStakeButtonsFrames[i].height+25)+150//+600;
                    col++;
                    if(col>2)
                    {   
                        col=0;            
                        row++
                    }
                }
            }
            // this.offsetY=this.offsetParent.y;
            // console.log('nn',this.offsetParent.y);
            // this.offsetParent.y=0;
        }
        else
        {   
      
       
            this.parent.y=0;
            this.parent.scale.set(1)
            this.betBGframe.alpha=1;


            //display in vertical mode (not the screen orientaion)
            for (var i = 0; i < this.betTitelStakeButtons.length; i++) {
                this.autoplayTitelStakeButtonsFrames[i].alpha=0;
         
                
            }

            
           
            this.defaultPos();

         

        }
        this.checkOpen()
    }

    
    private defaultPos=():void=>
    {
        this.betstacklevel=0;
        for (var i = 0; i < this.betTitelStakeButtons.length; i++) {
        if (this.activeGameData.isMobile) {
            // this.betTitelStakeButtons[i].lineStyle(5,0xff0000,1) ;

            this.betTitelStakeButtons[i].y = 85*this.activeGameData.gameScale * (this.betstacklevel ) + 0;
        }

        else {
        
     this.betTitelStakeButtons[i].y = 95 * (this.betstacklevel ) + 0;
        }
        if (i % 2 === 0) {
            this.betTitelStakeButtons[i].x = this.activeGameData.size[0] / 2 - this.betTitelStakeButtons[i].width//-10-100;
        }
        else {
            this.betTitelStakeButtons[i].x = this.activeGameData.size[0] / 2 + 10//-100+10;
            this.betstacklevel += 1;
        }
    }
        
    }

    private createTween=():void=> {

        this.betWindowTweens = [];
        for (var i = 0; i < this.betTitelStakeButtons.length; i++) {

            this.betWindowTweens[i] = PIXI.tweenManager.createTween(this.betTitelStakeButtons[i]);
            if (i % 2 == 0) {
                this.betWindowTweens[i].from({ y: this.betTitelStakeButtons[i].y + 90, alpha: 0 }).to({ y: this.betTitelStakeButtons[i].y, alpha: 1 });
            }
            else {
                this.betWindowTweens[i].from({ y: this.betTitelStakeButtons[i].y + 90, alpha: 0 }).to({ y: this.betTitelStakeButtons[i].y, alpha: 1 });
            }

            this.betWindowTweens[i].time = 0 + i * 25;
            // this.betWindowTweens[i].delay=i*20;
            this.betWindowTweens[i].easing = PIXI.tween.Easing.outBack();

            this.betWindowTweens[i].stop();
        }



        this.bgTween = PIXI.tweenManager.createTween(this.betBGframe);

        this.bgTween.from({ y: this.betBGframe.y + 90, alpha: 0 }).to({ y: this.betBGframe.y, alpha: 1 });

        this.bgTween.time = 0 + i * 50;
        // this.autoplayWindowTweens[i].delay=i*20;
        this.bgTween.easing = PIXI.tween.Easing.outBack();

        this.bgTween.stop();

    }


    private betSelectable=(bool: boolean):void=> {


        if (bool) {
            this.parent.alpha = 1;
            this.isOpen = bool;
            // console.log("Bet OPen")
            // this.playTween();
        }
        else {
            this.parent.alpha = 0;
            this.isOpen = bool;
            // console.log("Bet Close")

        }
        for (var i = 0; i < this.betTitelStakeButtons.length; i++) {
            this.betTitelStakeButtons[i].buttonMode = bool;
            this.betTitelStakeButtons[i].interactive = bool;
            // if (bool === false) {
            //     this.betTitelStakeButtons[i].alpha=0;
            // }

        }

    }

    // private playTween() {
    //     for (var i = 0; i < this.betTitelStakeButtons.length; i++) {
    //         this.betWindowTweens[i].reset();
    //         this.betWindowTweens[i].start();

    //     };
    //     this.bgTween.reset();
    //     this.bgTween.start();
    // }

    public setClosed()
    {
        // this.close();if()

        if(this.isOpen)
        {
            this.onClick();
        }
    }
    public onClick=():void=> {
        // console.log('OPEN SESAM',this.activeGameData.activePlaying )
        if (this.activeGameData.activePlaying === false) {
            if (this.isOpen) {
                this.portraitplayHidePlayBtnsUI(false)
                this.close();
                this.betBGframe.interactive=false;
             
            }
            else {
                this.open();
                this.betBGframe.interactive=true;
                // this.playTween()
                this.portraitplayHidePlayBtnsUI(true)
                this.betSelectable(true);

                if(this.activeGameData.BuyBonus!=undefined )
                {
                    this.activeGameData.BuyBonus.setHidden(true);                 
                 
                }
                // console.log("Bet OPen")
            }
        }
    }

    public isOpened=():boolean=>
    {
            return this.isOpen;
    }
    private checkOpen= ():void=>
    {
        // console.log(this.isOpen==false ,this.activeGameData.gameOption.getIsClosed())
        if(this.activeGameData.isMobile  && this.activeGameData.playOnPortrait)
        {
            if(this.isOpen==false && this.activeGameData.gameOption.getIsClosed())
            {
                this.activeGameData.gameBar.setMobileUIHidden(false);
            }
            else
            {
                this.portraitplayHidePlayBtnsUI(true)
            }
        }
        
    }
    private portraitplayHidePlayBtnsUI=(bool:boolean):void=>
    {   
        
        if(this.activeGameData.isMobile && this.activeGameData.playOnPortrait)
        {
            if(this.activeGameData.isMobile&&this.activeGameData.playOnPortrait&& window.matchMedia("(orientation: portrait)").matches)
            {
               
                this.activeGameData.gameBar.setMobileUIHidden(bool);
           
            }
            else
            {   
                if(this.activeGameData.gameOption!=undefined && this.activeGameData.gameOption.getIsClosed()==false)
                {
                    this.activeGameData.gameBar.setMobileUIHidden(true);
                }
                
                else
                {
                    this.activeGameData.gameBar.setMobileUIHidden(false);
                }
               
            }
        }
            
        
      
    }
    public removeFromCanvas() {
        this.portraitplayHidePlayBtnsUI(false)
        this.betSelectable(false);
        this.betBGframe.interactive=false;
        // console.log("BEt Close")

        if(this.activeGameData.BuyBonus!=undefined )
        {   
            if(this.activeGameData.betResponse.gameContext.contextData.bonus==false)
            {
                this.activeGameData.BuyBonus.setHidden(false);                 
         
            }
        
        }
    }
    public getFrame=():PIXI.Sprite=>
    {
        return this.betBGframe;
    }

  
    public getOffsetParent=():PIXI.Container=>
    {
        return this.offsetParent//
    }

    public getParent=():PIXI.Container=>
    {
        return this.parent;
    }
}




